<template>
	<div style="padding: 20px 20px 20px 0;">
		<!-- tab页 -->
		<el-tabs v-model="selectForm.type" @tab-click="$refs.selectForm.resetFields();getAll()">
			<el-tab-pane label="公寓" name="1">

			</el-tab-pane>
			<el-tab-pane label="商场" name="2">

			</el-tab-pane>
		</el-tabs>
		<div>
			<el-form :inline="true" :model="selectForm" ref="selectForm">
				
				<el-form-item v-if="selectForm.type==1" label="业主单位" prop="unitPay">
					<el-autocomplete style="width: 150px;" v-model="selectForm.unitPay"
						:fetch-suggestions="querySearchAsync" placeholder="请选择所属单位" value-key="unitName" clearable
						@clear="clearSearch" ref="myAutocomplete"></el-autocomplete>

					<!-- 	<el-select v-model="selectForm.unitPay">
						<el-option v-for="s in list" :label="s" :value="s"></el-option>
					</el-select> -->
					<!-- <el-input v-model="selectForm.roomNum" placeholder="房间号"></el-input> -->
				</el-form-item>
				<el-form-item v-if="selectForm.type==1" label="房间号" prop="roomNum">
					<el-autocomplete :disabled="title=='修改'" v-model="selectForm.roomNum"
						:fetch-suggestions="querySearchAsync" placeholder="请输入所属单位" value-key="roomNum" clearable
						@clear="clearSearch" ref="myAutocomplete"></el-autocomplete>
					<!-- <el-input v-model="selectForm.roomNum" placeholder="房间号"></el-input> -->
				</el-form-item>
				<el-form-item v-if="selectForm.flag==2" label="商铺号" prop="roomNum">
					<el-select v-model="selectForm.roomNum">
						<el-option v-for="s in list2" :label="s" :value="s"></el-option>
					</el-select>
					<!-- 	<el-input v-model="selectForm.roomNum" placeholder="商铺号"></el-input> -->
				</el-form-item>
				<el-form-item label="缴费户号" prop="accountNumber">
					<el-input v-model="selectForm.accountNumber" placeholder="房间号"></el-input>
				</el-form-item>
				<el-form-item label="缴费模式" prop="property">
					<el-select v-model="selectForm.property">
						<el-option label="单位缴纳" value="单位缴纳"></el-option>
						<el-option label="个人缴纳" value="个人缴纳"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="结清状态" prop="status">
					<el-select v-model="selectForm.status">
						<el-option label="未支付" value="未支付"></el-option>
						<el-option label="已支付" value="已支付"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAll">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="$refs.selectForm.resetFields();getAll();">重置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="downloadFile">下载导入模版</el-button>
				</el-form-item>
				<el-form-item>
					<el-upload v-if="selectForm.type==1" action="/api/admin/waterElectricityFee/apartment/importUtilities" name="file" :show-file-list="false"
						:headers="headerData" :on-success="success">
						<el-button type="primary">导入公寓水费记录</el-button>
					</el-upload>
					<el-upload v-if="selectForm.type==2" action="/api/admin/waterElectricityFee/mall/importUtilities" name="file" :show-file-list="false"
						:headers="headerData" :on-success="success">
						<el-button type="primary">导入商铺水费记录</el-button>
					</el-upload>
				</el-form-item> 
				<!--el-form-item>
					<el-button type="primary" @click="goAdd">新增</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="selectForm.flag==2" type="primary" @click="bysy">本月所有</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="selectForm.flag==2" type="primary" @click="byzd">本月指定</el-button>
				</el-form-item>
				<el-form-item>
					<div style="font-size: 25px;">共计{{count}}条记录</div>
				</el-form-item>
				<el-form-item>
					<div style="font-size: 25px;">共计{{sum}}元</div>
				</el-form-item-->
			</el-form>
		</div>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="roomName" v-if="selectForm.flag==1" label="房间号" align="center"></el-table-column>
			<el-table-column prop="shopName" v-if="selectForm.flag==2" label="商铺编号" align="center"></el-table-column>
			<el-table-column prop="accountNumber" label="缴费户号" align="center"></el-table-column>
			<el-table-column prop="accountName" label="缴费户名" align="center"></el-table-column>
			<el-table-column label="水费年月" align="center">
				<template slot-scope="{row}">
					{{row.year}}年{{row.month}}月
				</template>
			</el-table-column>
			<el-table-column prop="volume" label="当前用量" align="center"></el-table-column>
			<el-table-column prop="billPrice" label="缴费金额(元)" align="center"></el-table-column>
			<el-table-column prop="isPublic" label="是否公摊" align="center"></el-table-column>
			<el-table-column prop="status" label="结清状态" align="center"></el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<!-- 	<el-button type="text" @click="setRow(scope.row)">查看</el-button> -->
					<el-button type="text" @click="xgRow(scope.row)">修改</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 搜索条件 -->


		<!-- 分页 -->
		<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
			:page-size="selectForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
			style="margin-top: 10px;">
		</el-pagination>
		<el-dialog title="本月指定" :visible.sync="isByzd" width="40%">
			<el-form :model="formInline" class="demo-form-inline">
				<el-form-item label="商铺号" prop="roomNum">
					<el-select v-model="sfRoom">
						<el-option v-for="s in list2" :label="s" :value="s"></el-option>
					</el-select>
					<!-- 	<el-input v-model="selectForm.roomNum" placeholder="商铺号"></el-input> -->
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isByzd = false">取 消</el-button>
				<el-button type="primary" @click="sfQd">确定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="水费录入" :visible.sync="show" width="40%">
			<el-form :model="formInline" class="demo-form-inline" ref="formInline" :rules="rules">
				<el-row>
					<el-col v-if="selectForm.flag==1" :span="12">
						<el-form-item prop="roomNum" label="房间号" label-width="80px">
							<el-autocomplete :disabled="title=='修改'" v-model="formInline.roomNum"
								:fetch-suggestions="querySearchAsyncForRoom" placeholder="请输入所属单位" value-key="roomNum"
								clearable @clear="clearSearchRoom" ref="myAutocomplete"></el-autocomplete>
							<!-- <el-input v-model="formInline.roomNum" placeholder="房间号"></el-input> -->
						</el-form-item>
					</el-col>
					<el-col v-if="selectForm.flag==2" :span="12">
						<el-form-item prop="roomNum" label="商铺编号" label-width="80px">
							<el-select :disabled="title=='修改'" v-model="formInline.roomNum">
								<el-option v-for="s in list2" :label="s" :value="s"></el-option>
							</el-select>
							<!-- <el-input v-model="formInline.roomNum" placeholder="房间号"></el-input> -->
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="accountNumber" label="缴费户号" label-width="80px">
							<el-input v-model="formInline.accountNumber" placeholder="缴费户号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="accountName" label="缴费户名" label-width="80px">
							<el-input v-model="formInline.accountName" placeholder="缴费户名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item prop="consumption" label="当期水费" label-width="80px">
							<el-input v-model="formInline.consumption" placeholder="当期水费"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="title=='修改'">
					<el-col :span="12">
						<el-form-item label-width="80px" label="缴费模式" prop="property">
							<el-select v-model="formInline.property">
								<el-option label="单位缴纳" value="单位缴纳"></el-option>
								<el-option label="个人缴纳" value="个人缴纳"></el-option>
							</el-select>
						</el-form-item>

						<!-- <el-form-item label="缴费模式" label-width="80px">
							<el-input v-model="formInline.accountName" placeholder="缴费户名" ></el-input>
						</el-form-item> -->
					</el-col>

				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item prop="time" label="水费年月" label-width="80px">
							<el-date-picker v-model="formInline.time" value-format="yyyy-MM" type="month"
								placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col v-if="title=='修改'" :span="12">
						<el-form-item label-width="80px" label="结清状态" prop="status">
							<el-select v-model="formInline.status">
								<el-option label="未支付" value="未支付"></el-option>
								<el-option label="已支付" value="已支付"></el-option>
							</el-select>
						</el-form-item>

					</el-col>
				</el-row>
				<el-row v-if="selectForm.flag==2">
					<el-col :span="12">
						<el-form-item label="上传凭证">
							<el-upload class="avatar-uploader" action="/api/admin/roomManage/uploadRoomPictureFile" :show-file-list="false"
							 :on-success="handleAvatarSuccess" :headers="headerData" name="file" >
								<img v-if="formInline.showPath" :src="formInline.showPath" class="avatar" style="width: 150px;height: 150px;">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div>
							</el-upload>
							</el-upload>
						</el-form-item>
					</el-col>
					
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show = false">取 消</el-button>
				<el-button type="primary" @click="ok">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sfRoom:null,
				rules: {
					roomNum: [{
						required: true,
						message: "房间号不能为空",
						trigger: ["blur", "change"]
					}],
					accountNumber: [{
						required: true,
						message: "缴费户号不能为空",
						trigger: ["blur", "change"]
					}],
					accountName: [{
						required: true,
						message: "缴费户名不能为空",
						trigger: ["blur", "change"]
					}],
					consumption: [{
						required: true,
						message: "当期电量不能为空",
						trigger: ["blur", "change"]
					}],
					property: [{
						required: true,
						message: "缴费模式不能为空",
						trigger: ["blur", "change"]
					}],
					status: [{
						required: true,
						message: "结清状态不能为空",
						trigger: ["blur", "change"]
					}],
					time: [{
						required: true,
						message: "电费年月不能为空",
						trigger: ["blur", "change"]
					}],
				},
				activeName: "公寓",
				formInline: {
					roomNum: '',
					accountNumber: null,
					consumption: null,
					time: null,
					year: null,
					month: null,
					type: 1,
					flag: '1',
					accountName: null,
					property: null,
					status: null
				},
				oldFormInline: {

				},
				isByzd:false,
				headerData: {
					Authorization: localStorage.access_token
				},
				list: [],
				list2: [],
				form: { //表单数据
					name: "",
					age: ""
				},
				oldForm: undefined, //表单备份数据
				data: [{
					name: '111'
				}], //表格数据
				selectForm: { //查询条件
					type: '1', //所属类型（1公寓 2商铺）
					sort: '1', //缴费类别（1水费 2电费）
					isPublic: '',//1是公摊 0 不是
					roomId: '',
					shopId: '',
					status: null,
					company: '',//业主单位
					pageNum: 1, //当前页
					pageSize: 10, //页大小
				},
				oldSelectForm: {

				},
				totalNum: 0, //数据总数
				show: false, //控制弹窗
				count: null,
				sum: null,
				title: "",
				disable: false, //节流
			}
		},
		methods: {
			sfQd() {
				this.$http.get(`/api/schedule/test/addWater?shopNum=${this.sfRoom}`).then(res => {
					if (res.data.code == 0) {
						this.isByzd=false
						this.$message.success(res.data.message)
						this.getAll()
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			byzd() {
				this.isByzd = true
			},
			bysy() {
				this.$http.get("/api/schedule/test/1").then(res => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message)
						this.getAll()
					} else {
						this.$message.error(res.data.message)
					}
				})
			},
			handleAvatarSuccess(file) {
				console.log(file);
				this.formInline.filePath = file.data.filePath;
				this.formInline.showPath = file.data.showPath;
				console.log(this.formData);
			},
			clearSearchOwner() {
				this.$refs.myAutocompleteOwner.handleFocus()
			},
			querySearchAsyncForRoom(queryString, cb) {
				console.log(queryString)
			
				this.$http.get('/api/waterElectricityFee/selectRoomNumApartment?roomNum=' + queryString).then(
				res => {
					console.log("查询所有单位信息", res.data.data);
					let result = res.data.data;
					cb(result);
				})
			},
			querySearchAsync(queryString, cb) {
				this.$http.get('/api/ownerManage/getOwners?company=' + this.selectForm.unitPay).then(res => {
					console.log("查询所有单位信息", res);
					let result = res.data.data;
					cb(result);
				})
			},
			// 解决el-autocomplete使用clearable，失效问题
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},
			// goCheck(){
			// 	this.selectForm=JSON.parse(JSON.stringify(this.oldSelectForm))
			// 	this.getAll()
			// },
			getGyNumber() {
				this.$http.get("/api/bdWaterElectricityPayment/selectRoomNumApartment").then(res => {
					console.log(res)
					this.list = res.data.data
				})
			},
			getScNumber() {
				this.$http.get("/api/bdWaterElectricityPayment/selectRoomNumShop").then(res => {
					console.log(res)
					this.list2 = res.data.data
				})
			},
			xgRow(val) {
				this.show = true
				this.title = '修改'
				this.formInline = {
					...val
				}
			},
			goAdd() {
				this.show = true
				this.title = '新增'
				this.formInline = JSON.parse(JSON.stringify(this.oldFormInline))
			},
			ok() {
				console.log(this.formInline)
				this.$refs.formInline.validate((valid) => {
					if (valid) {
						if (this.selectForm.flag == '1') {
							this.formInline.flag = '1'
						} else {
							this.formInline.flag = '2'
						}
						this.formInline.year = parseInt(this.formInline.time.split("-")[0])
						this.formInline.month = parseInt(this.formInline.time.split("-")[1])
						this.formInline.time = null
						let url = "/api/bdWaterElectricityPayment/insert"
						if (this.title == '修改') {
							url = '/api/bdWaterElectricityPayment/update'
						}
						this.disable = true;
						this.$http.post(url, {
							...this.formInline
						}).then(res => {
							this.disable = false
							this.show = false
							this.$message.success(res.data.message)
							this.getAll()
							console.log(res)
						})
					} else {
						return;
					}

				})

				return
				// this.disable = true
				// let url = "/api/set"
				// if (this.title[0] == "新") {
				// 	url = "/api/add"
				// }
				// this.$http.post(url, this.form).then(res => {
				// 	this.disable = false
				// 	if (res.data.code == 0) {
				// 		this.show = false;
				// 		this.$message.success(`${this.title}成功`)
				// 		this.getAll();
				// 	} else {
				// 		this.$message.error(`${this.title}失败`)
				// 	}
				// })
			},
			setRow(row) { //修改被点击
				// this.form = JSON.parse(JSON.stringify(row))
				// this.title = "修改";
				// this.show = true;
				this.$router.push({
					name: '水电费详情',
					params: {
						val: row
					}
				})
			},
			close() { //弹框关闭
				this.$refs.form.resetFields()
				this.form = JSON.parse(JSON.stringify(this.oldForm));
			},
			success(res) {
				//console.log('res:',JSON.stringify(res));
				if (res.code == 0) {
					this.getAll()
					this.$message.success("导入成功")
				} else {
					this.$message.error(res.message)
					//this.isFail = true
					//this.czList = res.data
				}
			},
			downloadFile() { //下载导入模板
			console.log('selectForm22222:',JSON.stringify(this.selectForm))
				this.$http.get(`/api/waterElectricityFee/template/download?type=`+this.selectForm.type+'&sort='+this.selectForm.sort, {
					//...this.selectForm
				}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "公寓用水量导入模版.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
			},
			getAll() { //获取表格数据

				console.log('selectForm:',JSON.stringify(this.selectForm))
				this.$http.post(`/api/waterElectricityFee/query`, {
					...this.selectForm
				}).then(
					res => {
						//console.log('res.data:',JSON.stringify(res.data))
						if (res.data.code == 200) {
							this.data = res.data.rows;
							this.totalNum = res.data.total;
							this.count = this.totalNum
						} else {
							this.data = null
							this.totalNum = 0
							this.count = 0
						}
				
					})
			},
			sizeChange(size) { //页大小被修改
				this.selectForm.pageSize = size;
				this.getAll();
			},
			currentChange(page) { //当前页被修改
				this.selectForm.currentPage = page;
				this.getAll();
			}
		},
		mounted() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.oldFormInline = JSON.parse(JSON.stringify(this.formInline))
			this.oldSelectForm = JSON.parse(JSON.stringify(this.selectForm))
			this.getAll();
			//this.getGyNumber()
			//this.getScNumber()
		}
	}
</script>

<style>
</style>
